import {
  CLEAR_INVITATION_MESSAGE,
  SET_INVITATION_MESSAGE,
  SET_REFERRALS,
  SET_REFERRALS_ERROR,
  SET_REFERRALS_LOADING,
  SET_SENDING_INVITATION,
} from '../actions/referralActionTypes';

const initialState = {
  referrals: [],
  isLoading: false,
  error: null,
  sendingInvitation: false,
  invitationStatusMessage: '',
};

export default function referralReducer(state = initialState, action) {
  switch (action.type) {
    case SET_REFERRALS_LOADING:
      return {
        ...state,
        isLoading: action.loading,
      };

    case SET_REFERRALS:
      return {
        ...state,
        referrals: action.referrals,
      };

    case SET_REFERRALS_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case SET_SENDING_INVITATION:
      return {
        ...state,
        sendingInvitation: action.sending,
      };

    case SET_INVITATION_MESSAGE:
      return {
        ...state,
        invitationStatusMessage: action.message,
      };

    case CLEAR_INVITATION_MESSAGE:
      return {
        ...state,
        invitationStatusMessage: '',
      };

    default:
      return state;
  }
}
